import React from "react";

import { Add, Delete, DirectionsCarFilled, Send } from "@mui/icons-material";
import { Button as ButtonMaterial } from "@mui/material";

import BaseLabel from "components/BaseLabel";

import { Container } from "./styles";

interface IStyles {
  marginLeft?: string;
  marginRight?: string;
  marginTop?: string;
  marginBottom?: string;
  size?: string;
}

export interface IButton extends IStyles {
  id?: string;
  onClick?: any;
  children?: string | JSX.Element;
  type?: "button" | "submit" | "reset";
  icon?: string;
  backgroundColor?: string;
  borderColor?: string;
  backgroundHoverColor?: string;
  borderHoverColor?: string;
  textColor?: string;
  textColorHover?: string;
  textSize?: string;
  fontWeight?: string;
  width?: string;
  disabled?: boolean;
}

const ButtonMaterialIcons: Array<{
  name: string;
  icon: JSX.Element;
}> = [
  {
    name: "car",
    icon: <DirectionsCarFilled />,
  },
  {
    name: "send",
    icon: <Send />,
  },
  {
    name: "delete",
    icon: <Delete />,
  },
  {
    name: "add",
    icon: <Add />,
  },
  {
    name: "plus",
    icon: <Add />,
  },
];

const selectedIcon = (icon: string) => {
  return ButtonMaterialIcons.find((e) => e.name === icon)?.icon;
};

const Button: React.FC<IButton> = ({
  children,
  id,
  onClick,
  icon,
  type = "button",
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  backgroundColor,
  borderColor,
  backgroundHoverColor,
  borderHoverColor,
  textColor,
  textColorHover,
  textSize = "14px",
  fontWeight = "600",
  width = "100%",
  disabled,
}) => {
  const handleTypeChildren = () => {
    if (typeof children === "string") {
      return (
        <BaseLabel
          id="textButtonId"
          fontWeight={fontWeight}
          color={textColor}
          fontSize={textSize}
          colorHover={textColorHover}
        >
          {children}
        </BaseLabel>
      );
    }
    return children;
  };

  return (
    <Container
      id={id}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      marginTop={marginTop}
      type={type}
      backgroundColor={backgroundColor}
      borderColor={borderColor}
      backgroundHoverColor={backgroundHoverColor}
      borderHoverColor={borderHoverColor}
      textColor={textColor}
      textColorHover={textColorHover}
      onClick={onClick}
    >
      <ButtonMaterial
        disabled={disabled}
        data-cy={id}
        variant="contained"
        className="button"
        startIcon={icon ? selectedIcon(icon) : undefined}
        sx={{
          height: "40px",
          textTransform: "none",
          width: width ?? "20%",
          background: disabled ? "#d3d3d3!important" : "",
          border: disabled ? "none!important" : "",
        }}
      >
        {handleTypeChildren()}
      </ButtonMaterial>
    </Container>
  );
};

export default Button;
